export const Loader = () => {
    return (
        <>
            <span>
                <img src={require('../assets/img/loader.gif')} alt="loader" />
            </span>
        </>
    )
}